import { useState, useEffect } from "react";
import "./manageuserform.css";
import { useNavigate, useLocation } from 'react-router-dom';
import HttpClient from '../utils/HttpClient';
import toast from "react-hot-toast";

const ManageUserEditForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [first, setFirst] = useState("");
    const [last, setLast] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [organization, setOrganization] = useState("");
    const [address, setAddress] = useState("");
    const [image, setImage] = useState("");
    const [editId, setEditId] = useState(null);

    const backPage = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (location.state && location.state.row) {
            const { firstName, lastName, email, organizationName, address, image, id } = location.state.row;
            setFirst(firstName);
            setLast(lastName);
            setEmail(email);
            setOrganization(organizationName);
            setAddress(address);
            setImage(image);
            setEditId(id);
        }
    }, [location]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            return;
        }

        const data = {
            firstName: first,
            lastName: last,
            emailID: email,
            organizationName: organization,
            address: address,
            image: image,
        };

        const res = await HttpClient.requestData(`user-update/${editId}`, "PUT", data);
        console.log(res);
        if (res && res?.status) {
            toast.success("User data updated successfully");
            setImage("");
            setFirst("");
            setLast("");
            setAddress("");
            setOrganization("");
            setEmail("");
            navigate(-1);
        }
    };

    const handleImageChange = async (e) => {
        let file = e.target.files[0];
        if (!file) {
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error("Image size must be less than 5 MB");
            return;
        }

        let formData = new FormData();
        formData.append("image", file);

        try {
            let res = await HttpClient.fileUplode("image-upload", "POST", formData);
            if (res && res.status) {
                toast.success("Image Uploaded Successfully");
                setImage(res.url); // Assuming res.url contains the URL of the uploaded image
            } else {
                toast.error(res?.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            toast.error("Error uploading file");
        }
    };

    const handleRemoveImage = () => {
        setImage("");
        document.getElementById("profilePic").value = "";
    };

    const validate = () => {
        if (!first) {
            toast.error("First Name is required");
            return true;
        }
        if (!last) {
            toast.error("Last Name is required");
            return true;
        }
        if (!email) {
            toast.error("Email is required");
            return true;
        }
        if (!organization) {
            toast.error("Organization Name is required");
            return true;
        }
        if (!address) {
            toast.error("Address is required");
            return true;
        }
        if (!image) {
            toast.error("Profile Picture is required");
            return true;
        }
        return false;
    };

    return (
        <div className='userForm'>
            <div className="header">
                <b style={{fontSize:"20px", fontWeight:"400", cursor:"pointer"}}>EDIT USER</b>
                <b style={{ cursor:"pointer", color:"rgb(208, 38, 38)"}} onClick={backPage}>
                    <i className="fas fa-arrow-left" style={{marginRight: '8px'}}></i>
                    Back 
                </b>
            </div>
            <div className='addUser'>
                <b>EDIT USER</b>
            </div>

            {/* form started--------- */}
            <div className='userFormDiv'>
                <form onSubmit={handleSubmit}>
                    <div className='formHeader'>
                        <div>
                            First Name<br/><br/>
                            <input 
                                type="text" 
                                placeholder="First Name" 
                                value={first}
                                onChange={(e) => setFirst(e.target.value)} 
                            />
                        </div>
                        <div>
                            Last Name<br/><br/>
                            <input 
                                type="text" 
                                placeholder="Last Name" 
                                value={last}
                                onChange={(e) => setLast(e.target.value)} 
                            />
                        </div>
                    </div>

                    <div className='formFoot'>
                        <div>
                            Email<br/><br/>
                            <input 
                                type="email" 
                                placeholder="Email" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)} 
                            />
                        </div>
                        <div><br/>
                            Organization Name<br/><br/>
                            <input 
                                type="text" 
                                placeholder="Organization Name" 
                                value={organization}
                                onChange={(e) => setOrganization(e.target.value)} 
                            />
                        </div>
                        <div><br/>
                            <label htmlFor="address">Address:</label><br/>
                            <textarea 
                                id="address" 
                                name="address" 
                                value={address}
                                onChange={(e) => setAddress(e.target.value)} 
                            ></textarea>
                        </div>
                    </div>
                    <div className="file">
                        Profile Picture<br/>
                        <input 
                            type="file" 
                            id="profilePic" 
                            className="fileInput" 
                            onChange={handleImageChange} 
                        />
                        <label htmlFor="profilePic">Upload Profile Picture <i className="fas fa-upload"></i></label>
                        {image && (
                            <div>
                                <img src={image} alt="Profile" style={{ width: "100px", height: "100px" }} />
                                {/* <button type="button" onClick={handleRemoveImage}>Remove Image</button> */}<br/>
                            </div>
                        )}<br/>
                        <button style={{backgroundColor:"rgb(208, 38, 38)"}} type="submit">Edit</button>
                    </div>
                </form>
            </div>
            {/* form ended----------- */}

            {/* Footer */}
            <footer style={{ textAlign: "", marginTop: "20px" }}>
                <p style={{ fontSize: "12px", color: "#666" }}>Copyright © 2024 Psedge. All rights reserved.</p>
            </footer>
        </div>
    );
};

export default ManageUserEditForm;
